/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react";
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from 'axios';

import { isOnlyNumber } from "../../components/common/Common";

import Header from "../../components/includes/Header";
import HeaderTitle from "../../components/includes/HeaderTitle";
import "../../css/style.css";

//비밀번호 찾기
const EditPWD = () => {
  let mem_idx = 0;
  const navigate = useNavigate();
  const { backMode } = useParams();

  if(Number(backMode) === 0) mem_idx = Number(localStorage.getItem("foundIdx"));
  else mem_idx = Number(localStorage.getItem("mem_idx"));

  //입력정보저장객체
  const [varMember,setMember] = useState({});
  const [varCheckedMessage,setCheckedMessage] = useState('');

  useEffect(() => {
    const newMember = {mem_idx:mem_idx,mem_pwd:"",mem_pwd2:"",mem_oldpwd:"",chk_pass:0};
    if(Number(backMode) === 1) newMember.chk_pass = 1;
    setMember(newMember);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //입력값 처리
  const onChangeInputHandler = (e) => {
    const { name,value } = e.currentTarget;
    let svalue = isOnlyNumber(value);
    if(name === "mem_oldpwd" && varMember.chk_pass === 1) {
      setMember({...varMember,[name]:svalue,chk_pass:0});
      if(Number(backMode) === 1) {
        setCheckedMessage("");
        SetupInputButtons(false);
      }
    } else {
      setMember({...varMember,[name]:svalue});
    }
  }
  //기존비밀번호 확인
  const onCheckPasswordHandler = async(e) => {
    if (varMember.mem_oldpwd === "") {
      alert('기존의 비밀번호를 먼저 입력하세요.'); return false;
    }
    const sendData = {mem_idx:mem_idx,mem_pwd:varMember.mem_oldpwd};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_check_used_password`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      const smess = datas.message;
      if(datas.retvalue === 1) {
        setMember({...varMember,chk_pass:1});
        SetupInputButtons(true);
      } else {
        setMember({...varMember,mem_oldpwd:""});
      }

      setCheckedMessage(smess);
    });
  }

  const SetupInputButtons = (bmode) => {
    const pwd1Box = document.getElementsByName('mem_pwd')[0];
    const pwd2Box = document.getElementsByName('mem_pwd2')[0];
    if(bmode) {
      if(pwd1Box.classList.contains('hide')) pwd1Box.classList.remove('hide');
      if(pwd2Box.classList.contains('hide')) pwd2Box.classList.remove('hide');
    } else {
      if(!pwd1Box.classList.contains('hide')) pwd1Box.classList.add('hide');
      if(!pwd2Box.classList.contains('hide')) pwd2Box.classList.add('hide');
    }
  }

  //비밀번호 재저장
  const onUpdatePWDHandler = async (e) => {
    if(Number(backMode) === 1) {
      if (varMember.chk_pass === 0) {
        alert('기존의 비밀번호를 먼저 확인하세요.'); return false;
      }
    }
    if (varMember.mem_pwd === "") {
      alert('비밀번호를 먼저 입력하세요.'); return false;
    } else if (varMember.mem_pwd.length !== 4) {
      alert('비밀번호는 숫자로 4자리입니다.'); return false;
    } else if (varMember.mem_pwd2 === "") {
      alert('확인용 비밀번호를 먼저 입력하세요.'); return false;
    } else if (varMember.mem_pwd !== varMember.mem_pwd2) {
      alert('비밀번호와 확인용 비밀번호가 일치하지 않습니다.'); return false;
    }
    const sendData = {infos:varMember}
    await axios.post(`${process.env.REACT_APP_HOST}/_update_password`,sendData).then((res) => {
      const datas = res.data;
      alert(datas.message);
      if(datas.retvalue === 1) {
        if(Number(backMode) > 0) {
          localStorage.removeItem("mem_idx");
          localStorage.removeItem("mem_id");
          localStorage.removeItem("mem_mode");
          localStorage.removeItem("mem_name");
          localStorage.removeItem("mem_mobile");
          localStorage.removeItem("mem_carnumb");
          localStorage.removeItem("userLoginState");
        }
        if(Number(backMode) === 0) navigate('/Login');
        else navigate('/MyPage');
      }
    });
  }

  return (
    <div className="vh-container">
      <Header varGoToMain={false} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'비밀번호 변경하기'}/>
        <div className="vh-content-body">
          <div className="form-guide">
						<p>새로운 비밀번호를 설정하세요.</p>
					</div>
          {Number(backMode) === 0?null:
            <div className="form-group ms25 mb25">
              <label className="form-label">기존 비밀번호</label>
              <div className="field-group is-invalid">
                <input type="password" name="mem_oldpwd" value={varMember.mem_oldpwd||""} placeholder="기존 비밀번호를 입력하세요." className="form-control" onChange={onChangeInputHandler}/>
                <button name="check_pass" className="form-control-btn" onClick={e=>onCheckPasswordHandler(e)}>암호 확인</button>
              </div>
              <div className="invalid-tooltip">{varCheckedMessage}</div>
            </div>
          }
					<div className="form-group ms25 mb25">
						<label className="form-label">비밀번호</label>
						<div className="field-group is-invalid">
							<input type="password" name="mem_pwd" value={varMember.mem_pwd||""} placeholder="비밀번호를 입력하세요." maxLength={4} className={Number(backMode)===0?"form-control":"form-control hide"} onChange={onChangeInputHandler} />
						</div>
						<div className="invalid-tooltip">비밀번호는 숫자로 4자리입니다.</div>
					</div>
					<div className="form-group ms25 mb25">
						<label className="form-label">비밀번호 재확인</label>
						<div className="field-group is-invalid">
							<input type="password" name="mem_pwd2" value={varMember.mem_pwd2||""} placeholder="비밀번호를 다시 입력하세요." maxLength={4} className={Number(backMode)===0?"form-control":"form-control hide"} onChange={onChangeInputHandler} />
						</div>
						<div className="invalid-tooltip">비밀번호와 동일하게 입력해주세요.</div>
					</div>
					<div className="form-contoller flex-horizontal mt-auto mb50 ms25">
						<Link to={Number(backMode) === 0?"/Login":"//MyPage"} className="form-contoller-btn btn-white">취소</Link>
						<button className="form-contoller-btn" onClick={e=>onUpdatePWDHandler(e)}>비밀번호 재설정</button>
					</div>
        </div>
      </div>
    </div>
  );
}
export default EditPWD;